import React from 'react';
import { LightLayoutProvider } from '@uplift/ui-v2';
import { LightLayoutType } from '@uplift/types';

export const LightLayout: React.FC<LightLayoutType> = (props) => (
  <LightLayoutProvider {...props} showAvatar={false} />
);
